export const THERAPY_TYPES = [
    "cbt",
    "act",
    "dbt",
    "rebt",
    "psychoanalysis",
    "psychodynamic",
    "systemicFamily",
    "couples",
    "personCentered",
    "gestalt",
    "transpersonal",
    "emdr",
    "schema",
    "sfbt",
    "strategicBrief",
    "mbt",
    "pcit",
    "mbct",
    "fap",
    "narrative",
    "logotherapy",
    "transactionalAnalysis",
    "sensorimotor",
    "playTherapy",
    "artMusicTherapy",
    "neuroBiofeedback",
    "clinicalHypnosis",
    "mindfulness",
    "integrativeEclectic",
];

/**
 * A session's therapy types, as a therapist reads them.
 *
 * The field is stored as one comma-joined string of codes, because a session
 * may be worked in more than one way. Translating that string as a single key
 * is what put "transpersonal, systemicFamily" on the screen: no catalogue
 * entry is called that. Each code is looked up on its own, and anything the
 * catalogue does not know — an older free-text value — is shown as it was
 * typed rather than swallowed.
 */
export function formatTherapyTypes(
    /*
     * One key in, one string out. Deliberately not i18next's two-argument
     * `t(key, defaultValue)`: that overload's parameter list is not one
     * react-i18next's own `TFunction` can be passed to, so declaring it here
     * type-checked in the unit test and failed at every real call site.
     *
     * Nothing is lost. Whether the catalogue knows a code is a question this
     * module can answer for itself, which is a better place for it than
     * i18next's fallback anyway.
     */
    t: (key: string) => string,
    raw?: string | null
): string {
    return (raw ?? "")
        .split(",")
        .map((code) => code.trim())
        .filter(Boolean)
        .map((code) =>
            THERAPY_TYPES.includes(code) ? t(`session.therapyOptions.${code}`) : code
        )
        .join(", ");
}
